





import React,{ChangeEvent, useState, useContext} from 'react';
import {toast} from 'react-toastify'
import AuthContainer from '../features/authentication/components/AuthContainer'
import Layout from '../layout/Layout'
import Input from '../component/Input'
import Button from '../component/Button'
import axios from 'axios';
import { UserContext } from '../context/userContext';
import { isEmailValid, isPasswordValid } from '../util/middleware';

function ForgotPasswordPage() {
  const {setLocalUser,setUser} = useContext(UserContext);
  type authUser = {email:string}
  // ERRORS
  const [emailError, setEmailError] = useState<string>("");

  const [userInput,setUserInput] = useState<authUser>({'email':''})
  const {email} = userInput;

  const validateEmail = (value:string) => {
    let emailRes:(boolean|string)[] = isEmailValid(value);
    let isValidEmail:(boolean|string) =emailRes[0]===true ? emailRes[1] : "" 
    setEmailError(isValidEmail as string);
  };


  const handleChange = (e:ChangeEvent<HTMLInputElement>) => {
    // console.log('===============changing=============');
      e.preventDefault();
      const { value, id} = e.target;
      setUserInput((prev: authUser)=>({...prev,[id]:value}))       
      validateEmail(value);
      }

      const handleResetRequest= async() =>{
        // e.preventDefault();
        // console.log('==============Reseting===========');
            try {

                const newData:authUser = {email}
                
                const response =await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/resetPasswordRequest`,newData);
                if(response.status ===200){
                reset();
                toast.success("Reset Mail Sent !", {
                    position: toast.POSITION.TOP_CENTER
                  });
                }
                else{
                    toast.error("Couldn't Send Reset Mail !", {
                        position: toast.POSITION.TOP_CENTER
                      });
                }
                
            } catch (error) {
                toast.error(`${(error as any).message}`, {
                    position: toast.POSITION.TOP_LEFT
                  });                
                // console.log('My Error',error);
            }       
}
const reset = ()=>{
  setUserInput({'email':''})
}
  return (
    <div className='h-screen w-full'>
      <Layout>
      <AuthContainer>
      <h1 className='font-bold text-center' >Password Reset Request</h1>        
      <p className='text-left mt-1'>Email:</p>
      {emailError && <p className='text-red-500' >{emailError}</p>}
      <Input type={'text'} name={'email'} id={'email'} placeholder={'Enter email'} value={email} onChange={handleChange} required={true}/>

      <Button label={'Reset Request'} onClick={()=>!emailError?handleResetRequest():null}></Button>

      </AuthContainer>
      </Layout>
    </div>
  )
}

export default ForgotPasswordPage